export const locale = {
    lang: 'en',
    data: {
        GENERAL_INFO_PAGE: {
            TITLES: {
                CANCEL: 'Cancel',
                BACK: 'Back',
                GENERAL: 'General',
                SAVE: 'Save',
                EDIT: 'Edit',
            }
        }
    }
};